module.exports = __webpack_public_path__ + "file.png?d4b2242988738bfaccc36e19cda85bc4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/file.png
// module id = 640
// module chunks = 0 2 7 8 9 10 25 26